module.exports = __webpack_public_path__ + "img/left-arrow.0c6bd91b.svg";